<app-dialog-header headerIcon="webhook" *ngIf="dialogForm.get('WebhookID')?.value == 0"
	headerText="Add {{dialogForm.get('Type')?.value}} Integration" (onCloseClick)="onCancelClick()"></app-dialog-header>
<app-dialog-header headerIcon="webhook" *ngIf="dialogForm.get('WebhookID')?.value != 0"
	headerText="Modify {{dialogForm.get('Type')?.value}} Integration"
	(onCloseClick)="onCancelClick()"></app-dialog-header>

<form [formGroup]="dialogForm" >
	<div mat-dialog-content style="min-width: 500px;max-height: 90vh !important;">
		<mat-form-field>
			<mat-label>integrationID:</mat-label>
			<input matInput autocomplete="off" readonly formControlName="WebhookUID" required>
			<mat-error *ngIf="dialogForm.get('WebhookUID')!.hasError('required')">WebhookUID is required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>NeuronSensorAPI:</mat-label>
			<input matInput autocomplete="off" formControlName="NeuronSensorAPI">
			<mat-error *ngIf="dialogForm.get('NeuronSensorAPI')!.hasError('required')">Neuron Sensor API is
				required</mat-error>
		</mat-form-field>
		<mat-form-field *ngIf="dialogForm.get('NeuronSensorSystem')?.value">
			<mat-label>Description:</mat-label>
			<input matInput autocomplete="off" formControlName="Description">
			<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">Description is required</mat-error>
		</mat-form-field>
		<div *ngIf="dialogForm.get('NeuronSensorSystem')?.value">
			<mat-label>ClientWebhookID:</mat-label>
			<span class="alignRow" style="display: flex; align-items: center; gap: 1em;">
				<!-- Dropdown takes remaining space -->
				<span style="flex: 1;">
					<ejs-dropdownlist style="background-color: #F5F5F5;" id="webhooks" #WebhookDropdown
						[dataSource]='IntegrationList' [value]="selectedId" (change)="onDropdownChange($event)"
						[fields]='fields' [placeholder]='waterMark' [popupHeight]='200'>
					</ejs-dropdownlist>
				</span>

				<!-- Fixed-width icon -->
				<span class="app-icon app-icon--add" style="text-align: center;" *ngIf="SystemsRetrieved" (click)="addWebhook()">
					<mat-icon matTooltip="Add new NeuronSensor Webhook" matTooltipPosition="above" />
				</span>
			</span>
		</div>

		<div *ngIf="selectedIntegration && selectedIntegration.headers"
			style="font-size: 12px;margin:5px 0 5px 0;padding:10px;border:1px solid #ccc;border-radius:5px;background-color:#f9f9f9;">
			<table style="width: 100%;">
				<colgroup>
					<col style="width: 120px;">
					<col style="width: 200px;">
					<col style="width: 50px;">
					<col style="width: auto;">
					<col style="width: 30px;">
				</colgroup>
				<tbody>
					<tr>
						<th>Name:</th>
						<td colspan="3"
							[ngStyle]="{ color: selectedIntegration.name.includes(dialogForm.get('WebhookUID')?.value) ? 'green' : 'red' }">
							<span class="alignRow">
								<span>{{selectedIntegration.name}}</span>
								<span class="alignRow" matTooltip="Check Webhook name!  Is this webhook created for this Integration?"
									style="color: red;"
									*ngIf="!selectedIntegration.name.includes(dialogForm.get('WebhookUID')?.value)">
									<mat-icon>error_outline</mat-icon>
								</span>
							</span>
						</td>
						<td>
							<span class="alignRow" style="text-align: right;" matTooltip="Fix Webhook name"
								matTooltipPosition="left" (click)="updateWebhookName(selectedIntegration)"
								*ngIf="!selectedIntegration.name.includes(dialogForm.get('WebhookUID')?.value)">
								<mat-icon>sync</mat-icon>
							</span>
						</td>
					</tr>
					<tr>
						<th>ID:</th>
						<td>{{selectedIntegration.id}}</td>
						<th>Enabled</th>
						<td>
							<span [ngSwitch]="selectedIntegration.disabled" class="alignRow">
								<mat-slide-toggle #switchWebhookEnabled [checked]="selectedIntegration.disabled < 100"
									color="primary" (mousedown)="nsEnable($event)">
								</mat-slide-toggle>
								<span style="color: green;"
									*ngIf="selectedIntegration.disabled == 0">&nbsp;(Enabled)</span>
								<span style="color: gold;" *ngIf="selectedIntegration.disabled > 0 && 
									selectedIntegration.disabled < 100">&nbsp;(Warning)</span>
								<span style="color: red;"
									*ngIf="selectedIntegration.disabled >= 100">&nbsp;(Disabled)</span>
							</span>
						</td>
						<td>
							<!-- *ngIf="!headersOK" -->
							<span class="alignRow" style="text-align: right;" matTooltip="Fix Webhook Configuration"
							
								matTooltipPosition="left" (click)="updateWebhookDetails(selectedIntegration)">
								<mat-icon>auto_fix_high</mat-icon>
							</span>
						</td>
					</tr>
					<tr>
						<th style="vertical-align: top;">URL:</th>
						<td colspan="3" style="max-width: 300px; word-break: break-all;">
							<span class="alignRow">{{ selectedIntegration.endpoint }}</span>
						</td>
						<td style="vertical-align: top;">
							<mat-icon style="color: green;"
								*ngIf="selectedIntegration.endpoint === this.dialogForm.get('FQN')?.value">verified</mat-icon>
							<mat-icon style="color: red;"
								*ngIf="selectedIntegration.endpoint != this.dialogForm.get('FQN')?.value">error_outline</mat-icon>
						</td>
					</tr>
					<tr *ngFor="let key of requiredHeaders">
						<th>{{ key }}:</th>
						<td colspan="3">
							<span class="alignRow">
								<span>{{ selectedIntegration.headers[key] || 'Missing' }}</span>
								<span *ngIf="selectedIntegration.headers[key]" [ngSwitch]="key">
									<span *ngSwitchCase="'AccountUID'">&nbsp;({{getAccountName(selectedIntegration.headers[key])}})</span>
									<span *ngSwitchCase="'OrganisationUID'">&nbsp;({{getOrganisationName(selectedIntegration.headers[key])}})</span>
								</span>
							</span>
						</td>
						<td>
							<span [ngSwitch]="getHeaderExists(key)" class="alignRow">
								<mat-icon style="color: green;" *ngSwitchCase=true>verified</mat-icon>
								<mat-icon style="color: red;" *ngSwitchCase=false>error_outline</mat-icon>
							</span>

						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>AutoBuild:</mat-label>
				<mat-slide-toggle #switchAutoBuild formControlName="AutoBuild" color="primary"></mat-slide-toggle>
			</div>
		</div>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Enabled:</mat-label>
				<mat-slide-toggle #switchEnabled formControlName="Enabled" color="primary"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<!-- <div>dialogForm.dirty:{{dialogForm.dirty}}</div>
	<div>dialogForm.invalid:{{dialogForm.invalid}}</div>
	<div>dialogForm.get('NeuronSensorAPI')!.hasError('required'):{{dialogForm.get('NeuronSensorAPI')!.hasError('required')}}</div>
	<div>dialogForm.get('NeuronSensorSystem')!.hasError('required'):{{dialogForm.get('NeuronSensorSystem')!.hasError('required')}}</div>
	<div>dialogForm.get('ClientWebhookID')!.hasError('required'):{{dialogForm.get('ClientWebhookID')!.hasError('required')}}</div>
	<div>dialogForm.get('Description')!.hasError('required'):{{dialogForm.get('Description')!.hasError('required')}}</div> -->
	<!-- <div>nsWebhookNameValid:{{nsWebhookNameValid}}</div> -->
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value"
			[disabled]="dialogForm.invalid || !dialogForm.dirty || !nsWebhookNameValid">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>